var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5022 6.72689C19.5022 5.23208 18.0715 4.15285 16.6342 4.56343L16.4282 3.84228L16.6342 4.56343L12.132 5.8495C11.166 6.12544 10.5 7.00833 10.5 8.01297V18.75C10.5 20.6671 8.68722 22 6.75 22C4.81278 22 3 20.6671 3 18.75C3 16.8327 4.8128 15.5 6.75 15.5C7.56365 15.5 8.35535 15.7351 9 16.1499V8.01297C9 6.33858 10.11 4.86709 11.72 4.40719L16.2222 3.12112C18.6177 2.43682 21.0022 4.23555 21.0022 6.72689V15.75C21.0022 17.6671 19.1895 19 17.2522 19C15.3149 19 13.5022 17.6671 13.5022 15.75C13.5022 13.8327 15.3149 12.5 17.2522 12.5C18.0659 12.5 18.8576 12.7351 19.5022 13.1498V6.72689ZM19.5022 15.75C19.5022 14.9056 18.6287 14 17.2522 14C15.8757 14 15.0022 14.9056 15.0022 15.75C15.0022 16.5942 15.8757 17.5 17.2522 17.5C18.6287 17.5 19.5022 16.5942 19.5022 15.75ZM9 18.75C9 17.9056 8.1265 17 6.75 17C5.3735 17 4.5 17.9056 4.5 18.75C4.5 19.5942 5.37352 20.5 6.75 20.5C8.12648 20.5 9 19.5942 9 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.85c263217c3a2608786329291493dd06.svg";
export { ForwardRef as ReactComponent };